import type { Environment } from '@1debit/analytics';
import { Analytics } from '@1debit/analytics';
import getConfig from 'next/config';

// Lazy-init to avoid calling generateDeviceId during SSR,
// which accesses browser globals (window/document).
let _handler: Analytics | undefined;

export function getAnalyticsHandler(): Analytics {
  if (typeof window === 'undefined') {
    return ({
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      trackEvent() {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      trackPage() {},
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      init() {},
    } as unknown) as Analytics;
  }
  if (!_handler) {
    const { publicRuntimeConfig } = getConfig();
    const env = (publicRuntimeConfig?.deployEnvironment ||
      'development') as Environment;
    _handler = new Analytics({
      env,
      applicationName: 'pay-anyone-client',
      variant: 'onlyEventRouter',
    });
  }
  return _handler;
}
